import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { DynamicComponent } from 'ctm-components';
import { ResponsiveLayout } from '@comparethemarketau/manor-layout';

import { ApplicationErrorModal } from './application_error_modal';
import { ApplicationErrorInfoXs } from './application_error_info_xs';
import { ApplicationErrorInfo } from './application_error_info';
import { PreloadImage } from './common/preload_image';

const _ApplicationError = ({ visible }) => {
    return (
        <div className={classNames('test-applicationError')}>
            <DynamicComponent component={(
                <>
                    <ApplicationErrorModal visible={visible}>
                        <ResponsiveLayout is="xs">
                            <ApplicationErrorInfoXs />
                        </ResponsiveLayout>
                        <ResponsiveLayout isFrom="sm">
                            <ApplicationErrorInfo />
                        </ResponsiveLayout>
                    </ApplicationErrorModal>
                    <PreloadImage />
                </>
            )} />
        </div>
    );
};

_ApplicationError.propTypes = {
    visible: PropTypes.bool
};

const mapStateToProps = (state) => {
    const serverError = state.getIn(['error', 'serverError']);
    const internalError = state.getIn(['error', 'internalError']);
    const visible = !!(serverError || internalError);
    return {
        visible,
        serverError,
        internalError
    };
};

const ApplicationError = connect(mapStateToProps)(_ApplicationError);

export { ApplicationError, _ApplicationError };
